import { DatePipe } from '@angular/common';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import momentTimezone, { Moment } from 'moment-timezone';
import { Observable, Subject } from 'rxjs';
import { Constants, DateService, WarningDialog } from 'src/app/shared/index';
import { environment } from '../../environments/environment';
import { API_ENDPOINT$, OPEN_WEATHER_ENDPOINT$ } from '../shared/index';
@Injectable()
export class CommonService {
  private weatherUrl = OPEN_WEATHER_ENDPOINT$;
  private plantLogoUrl = `${API_ENDPOINT$}/common/image/Logo`;
  private plantLayoutUrl = `${API_ENDPOINT$}/common/image/Layout`;
  private solarNodeImageUrl = `${API_ENDPOINT$}/common/solarimage/TreeNodeImage`;
  private plantSolarLayoutUrl = `${API_ENDPOINT$}/common/solarimage/Solar_Layout`;
  private generateDailySolarReport = `${API_ENDPOINT$}/solar/generateDailySolarReport`;
  private generateMonthlySolarReport = `${API_ENDPOINT$}/solar/generateMonthlySolarReport`;
  private generateDailyEnergyReport = `${API_ENDPOINT$}/energy/generateDailyReport`;
  private generateMonthlyEnergyReport = `${API_ENDPOINT$}/energy/generateMonthlyReport`;
  private generateSiteReport = `${API_ENDPOINT$}/report/generateSiteReport`;
  private generateEnergyTreeReport = `${API_ENDPOINT$}/report/generateEnergyTreeReport`;
  // Export
  private getRealTimeDataExport = `${API_ENDPOINT$}/report/exportData`;
  // Manage report
  private generateManageReport = `${API_ENDPOINT$}/report/manageReport`;
  // Add Node
  nodeDetailSubject: Subject<any>;
  nodeTreeDetailSubject: Subject<any>;
  isDialogOpened = false;
  selectedSiteInLoadInventory = '';
  constructor(
    private http: HttpClient,
    private dateService: DateService,
    handler: HttpBackend,
    public dialog: MatDialog,
    private datePipe: DatePipe
  ) {
    this.nodeDetailSubject = new Subject<any>();
    this.nodeTreeDetailSubject = new Subject<any>();
  }
  getWeatheritemsbyCity(cityName: string): Observable<any> {
    return this.http.get(
      this.weatherUrl +
        'weather?q=' +
        cityName +
        '&appid=' +
        environment.appId +
        '&units=' +
        environment.units
    );
  }

  getWeatherForecast(cityName: string): Observable<any> {
    return this.http.get(
      this.weatherUrl +
        'forecast?q=' +
        cityName +
        '&appid=' +
        environment.appId +
        '&units=' +
        environment.units
    );
  }
  public getPlantLogoUrl(siteId: string): string {
    return this.plantLogoUrl + '/' + siteId;
  }
  public getPlantLayoutUrl(siteId: string): string {
    return this.plantLayoutUrl + '/' + siteId;
  }
  public getSolarNodeImageUrl(siteId: string, attachementId: string): string {
    return this.solarNodeImageUrl + '/' + siteId + '/' + attachementId;
  }
  public getplantSolarLayoutUrl(siteId: string): string {
    return this.plantSolarLayoutUrl + '/' + siteId + '/' + 'undefined';
  }
  public getgenerateDailySolarReportUrl(siteId: string, date: string): string {
    return this.generateDailySolarReport + '/' + siteId + '/' + date;
  }
  public getgenerateMonthlySolarReportUrl(
    siteId: string,
    date: string
  ): string {
    return this.generateMonthlySolarReport + '/' + siteId + '/' + date;
  }
  public getDailyEnergyReportUrl(siteId: string, date: string): string {
    return this.generateDailyEnergyReport + '/' + siteId + '/' + date;
  }
  public getMonthlyEnergyReportUrl(siteId: string, date: string): string {
    return this.generateMonthlyEnergyReport + '/' + siteId + '/' + date;
  }
  public getgenerateSiteReportUrl(siteId: string): string {
    return this.generateSiteReport + '/' + siteId;
  }
  public getGenerateManageReport(siteId: string, date: string): string {
    return this.generateManageReport + '/' + siteId + '/' + date;
  }
  public getEnergyTreeReportUrl(
    siteId: string,
    date: string,
    enddate: string
  ): string {
    return (
      this.generateEnergyTreeReport + '/' + siteId + '/' + date + '/' + enddate
    );
  }

  /**
   * Function used in RealtimeDataComponent
   *
   * @param {string} siteId
   * @param {String} meterId
   * @param {string} date
   * @param {string} enddate
   * @return {*}  {string}
   * @memberof CommonService
   */
  public getRealTimeDataExportUrl(
    siteId: string,
    meterId: String,
    date: string,
    enddate: string
  ): string {
    return (
      this.getRealTimeDataExport +
      '/' +
      siteId +
      '/' +
      meterId +
      '/' +
      date +
      '/' +
      enddate
    );
  }

  public buildLoadParams(load, forAlertConfig) {
    let loadParamArr = [];
    let allElectricalParams = [];
    let otherParams = [];
    const allHarmonicParams = [
      { text: 'thd_ia', value: 'thd_ia' },
      { text: 'thd_ib', value: 'thd_ib' },
      { text: 'thd_ic', value: 'thd_ic' },
      { text: 'thd_i', value: 'thd_i' },
      { text: 'thd_va', value: 'thd_va' },
      { text: 'thd_vb', value: 'thd_vb' },
      { text: 'thd_vc', value: 'thd_vc' },
      { text: 'thd_v', value: 'thd_v' },
      { text: 'h3_ia', value: 'h3_ia' },
      { text: 'h3_ib', value: 'h3_ib' },
      { text: 'h3_ic', value: 'h3_ic' },
      { text: 'h3_va', value: 'h3_va' },
      { text: 'h3_vb', value: 'h3_vb' },
      { text: 'h3_vc', value: 'h3_vc' },
      { text: 'h5_ia', value: 'h5_ia' },
      { text: 'h5_ib', value: 'h5_ib' },
      { text: 'h5_ic', value: 'h5_ic' },
      { text: 'h5_va', value: 'h5_va' },
      { text: 'h5_vb', value: 'h5_vb' },
      { text: 'h5_vc', value: 'h5_vc' },
      { text: 'h7_ia', value: 'h7_ia' },
      { text: 'h7_ib', value: 'h7_ib' },
      { text: 'h7_ic', value: 'h7_ic' },
      { text: 'h7_va', value: 'h7_va' },
      { text: 'h7_vb', value: 'h7_vb' },
      { text: 'h7_vc', value: 'h7_vc' }
    ];
    const paramTemperature = { text: 'Temperature', value: 'ambient_temp' };
    const paramPressure = { text: 'Pressure', value: 'ambient_pressure' };
    const paramCFMOutput = { text: 'CFM Output', value: 'CFM' };
    const fuelParam = { text: 'Fuel Consumption', value: 'fuelConsumption' };
    const irdSensorOutput = {
      text: 'Irradiation Sensor Output',
      value: 'IrradiationSensorOutput'
    };
    if (forAlertConfig === true) {
      allElectricalParams = [
        'On Duration',
        'Energy',
        'Real Time Power',
        'Voltage',
        'Current',
        'Power Factor' /* 'Shiftwaise Energy' */
      ];
    } else {
      allElectricalParams = [
        { text: 'current', value: 'current' },
        { text: 'currentA', value: 'currentA' },
        { text: 'currentB', value: 'currentB' },
        { text: 'currentC', value: 'currentC' },
        { text: 'voltage', value: 'voltage' },
        { text: 'voltageA', value: 'voltageA' },
        { text: 'voltageB', value: 'voltageB' },
        { text: 'voltageC', value: 'voltageC' },
        { text: 'frequency', value: 'Frequency' },
        { text: 'powerfactor', value: 'powerfactor' },
        { text: 'powerfactorA', value: 'powerfactorA' },
        { text: 'powerfactorB', value: 'powerfactorB' },
        { text: 'powerfactorC', value: 'powerfactorC' },
        { text: 'realtimepower', value: 'realtimepower' },
        { text: 'realtimeenergy', value: 'realtimeenergy' },
        { text: 'registerenergy', value: 'registerenergy' }
      ];

      otherParams = [
        paramTemperature,
        paramPressure,
        paramCFMOutput,
        fuelParam,
        irdSensorOutput
      ];
    }
    otherParams = [
      paramTemperature,
      paramPressure,
      paramCFMOutput,
      fuelParam,
      irdSensorOutput
    ];
    if (load.parameters != null) {
      for (let j = 0; j < load.parameters.length; j++) {
        const param = load.parameters[j];
        switch (param.name) {
          case Constants.LOAD_PARAM.ALL_ELECTRICAL:
            loadParamArr = loadParamArr.concat(allElectricalParams);
            break;
          case Constants.LOAD_PARAM.TEMPERATURE:
            loadParamArr.push(paramTemperature);
            loadParamArr = loadParamArr.concat(irdSensorOutput);
            break;
          case Constants.LOAD_PARAM.PRESSURE:
            loadParamArr.push(paramPressure);
            break;
          case Constants.LOAD_PARAM.FLOW_OUTPUT:
            loadParamArr.push(paramCFMOutput);
            loadParamArr.push(fuelParam);
            break;
          case Constants.LOAD_PARAM.ALL_HARMONIC:
            loadParamArr = loadParamArr.concat(allHarmonicParams);
            break;
          default:
            if (forAlertConfig === true) {
              loadParamArr.push(param.name);
            } else {
              loadParamArr.push({ text: param.name, value: param.name });
            }
        }
      }
    }
    if (loadParamArr.length === 0) {
      loadParamArr = allElectricalParams.concat(otherParams);
    }
    return loadParamArr;
  }

  public initVariables() {
    const news = [
      {
        NewsList: [
          {
            CategoryList: [
              {
                CategoryName: 'Power',
                DisplayName: 'Power',
                ID: 9
              },
              {
                CategoryName: 'Voltage',
                DisplayName: 'Voltage',
                ID: 10
              }
            ]
          },
          {
            CategoryList: [
              {
                CategoryName: 'Current',
                DisplayName: 'Current',
                ID: 6
              }
            ]
          }
        ],
        RelatedNews: Constants.NULL_VALUE
      }
    ];
    return {
      monitorPowVar: {
        moniPowerData: {
          timeRangeLbl: [
            { id: Constants.one, name: '5min' },
            { id: Constants.two, name: '15min' },
            { id: Constants.three, name: '30min' },
            { id: Constants.four, name: '1hr' }
          ],
          multiSelectRange: [
            { id: 'power', name: 'Power' },
            { id: 'current', name: 'Current' },
            { id: 'voltage', name: 'Voltage' }
          ],
          multipleSelect: [],
          multiSelectData: {
            data: news,
            multipleVlaue: [],
            abms: [],
            obj: {}
          },
          showMultiSelectDiv: Constants.BOOLEAN_FALSE,
          timeRangeVal: '3'
        },
        datesSelected: {
          startDate: this.dateService.subDay(new Date(), 1),
          endDate: this.dateService.subDay(new Date(), 1)
        },

        datesSelectedRealTime: {
          startDate: this.dateService.getCurDateFn(),
          endDate: this.dateService.getCurDateFn()
        },
        datesSelectedHydraulic: {
          startDate: this.dateService.getCurDateFn(),
          endDate: this.dateService.getCurDateFn()
        },
        datesSelectedTestBenchStatus: {
          startDate: this.dateService.getCurDateFn(),
          endDate: this.dateService.getCurDateFn()
        },
        datesSelectedComparisionAnalysis: {
          startDate: this.dateService.subDay(new Date(), 1),
          endDate: this.dateService.subDay(new Date(), 1)
        },
        datesSelectedExcelSheet: {
          startDate: this.dateService.subDay(new Date(), 15),
          endDate: this.dateService.getCurDateFn()
        },
        reportdate: {
          startDate: this.dateService.getCurDateFn(),
          endDate: this.dateService.getCurDateFn()
        },
        datesSelectedOntimeAnalysis: {
          startDate: this.dateService.subDay(new Date(), 7),
          endDate: this.dateService.getCurDateFn()
        },
        datesSelectedLoadingAnalysis: {
          startDate: this.dateService.subDay(new Date(), 1),
          endDate: this.dateService.subDay(new Date(), 1)
        },
        datesSelectedLiveEQ: {
          startDate: this.dateService.subDay(new Date(), 2),
          endDate: this.dateService.subDay(new Date(), 1)
        },
        datesSelectedSettingEQ: {
          startDate: this.dateService.getCurDateFn(),
          endDate: this.dateService.getCurDateFn()
        },
        datesSelectedEnergyTrend: {
          startDate: this.dateService.subDay(new Date(), 3),
          endDate: this.dateService.subDay(new Date(), 1)
        },
        datesSelectedPowerSupply: {
          startDate: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          ),
          endDate: this.dateService.getCurDateFn()
        },
        datesSelectedPowerConsumption: {
          startDate: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          ),
          endDate: this.dateService.getCurDateFn()
        },
        rangesOntimeAnalysis: {
          'Last 7 days': [this.dateService.subDay(new Date(), 7), new Date()],
          'Last 30 days': [this.dateService.subDay(new Date(), 30), new Date()],
          'This month': [moment().startOf('month'), moment().endOf('month')]
        },
        ranges: {
          Yesterday: [
            this.dateService.subDay(new Date(), 1),
            this.dateService.subDay(new Date(), 1)
          ],
          'Last 7 days': [this.dateService.subDay(new Date(), 7), new Date()],
          'Last 30 days': [this.dateService.subDay(new Date(), 30), new Date()],
          'This month': [moment().startOf('month'), moment().endOf('month')]
        },
        realtimeranges: {
          Today: [new Date(), new Date()],
          Yesterday: [
            this.dateService.subDay(new Date(), 1),
            this.dateService.subDay(new Date(), 1)
          ],
          'Last 7 days': [this.dateService.subDay(new Date(), 7), new Date()],
          'Last 30 days': [this.dateService.subDay(new Date(), 30), new Date()],
          'This month': [moment().startOf('month'), moment().endOf('month')]
        },
        news: news
      }
    };
  }
  uniqueArray(a) {
    const seen = {};
    const out = [];
    const len = a.length;
    let j = 0;
    for (let i = 0; i < len; i++) {
      const item = a[i];
      if (seen[item] !== 1) {
        seen[item] = 1;
        out[j++] = item;
      }
    }
    return out;
  }
  // Common Function for Add Node
  public sendNodeDetailSubject = (value: any) => {
    this.nodeDetailSubject.next(value);
  };
  public getNodeDetailSubject = (): Observable<any> => {
    return this.nodeDetailSubject.asObservable();
  };
  public unNodeDetailSubjectSubject = () => {
    this.nodeDetailSubject.observers = [];
  };
  // Common Function for Add Node (From 12)
  public sendNodeTreeDetailSubject = (value: any) => {
    this.nodeTreeDetailSubject.next(value);
  };
  public getNodeTreeDetailSubject = (): Observable<any> => {
    return this.nodeTreeDetailSubject.asObservable();
  };
  public unNodeTreeDetailSubjectSubject = () => {
    this.nodeTreeDetailSubject.observers = [];
  };
  public isNullOrUndefined = (x) => {
    if (x == null) {
      return true;
    }

    if (x === null) {
      return true;
    }

    if (typeof x === 'undefined') {
      return true;
    }
    return false;
  };
  isImageFile(file) {
    return file.name.match(/.(jpg|jpeg|png|gif)$/i);
  }
  showDialogMessage(message) {
    // if (this.dialog.openDialogs.length === 0) {
    this.isDialogOpened = true;
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = message;
    // dialogRef.componentInstance.buttonConfig = [new ButtonConfig('Close', false, true, () => dialogRef.close(false))];
    dialogRef.afterClosed().subscribe(() => {});
    // }
  }
  /* function that returns boolean in case the browser is Internet Explorer*/
  isIE() {
    const ua = navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    const is_ie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
    return is_ie;
  }
  isLaterThanCurentDate(date: any) {
    return moment(date).isAfter(moment(), 'days');
  }

  /**
   * Function to convert value of Date into String
   *
   * @param {FormControl} date
   * @return {*}
   * @memberof CommonService
   */
  transform(date: FormControl) {
    if (date.valid) {
      return this.datePipe.transform(date.value, 'yyyy-MM-dd');
    } else {
      return '';
    }
  }

  /**
   * Function call to check validations for Start Date
   *
   * @param {number} dateBound
   * @param {FormControl} startDateCtr
   * @param {FormControl} endDateCtr
   * @param {boolean} isValidStartDate
   * @param {boolean} isValidEndDate
   * @param {String} startDateErrorMessage
   * @param {String} endDateErrorMessage
   * @return {*}
   * @memberof CommonService
   */
  validateStartDate(
    dateBound: number,
    startDateCtr: FormControl,
    endDateCtr: FormControl,
    isValidStartDate: boolean,
    isValidEndDate: boolean,
    startDateErrorMessage: String,
    endDateErrorMessage: String
  ) {
    if (!startDateCtr.invalid && startDateCtr.value != null) {
      isValidEndDate = true;
      endDateCtr.setErrors(null);
      var one_day = 1000 * 60 * 60 * 24;
      const fromDate = new Date(this.transform(startDateCtr));
      const toDate = new Date(this.transform(endDateCtr));

      if (fromDate > toDate || endDateErrorMessage == 'Invalid date.') {
        isValidStartDate = false;
        startDateErrorMessage =
          'Start date must be equal or less than End date';
        startDateCtr.setErrors({ invalidDate: true });
        return {
          startDateCtr,
          endDateCtr,
          isValidEndDate,
          isValidStartDate,
          startDateErrorMessage,
          endDateErrorMessage
        };
      }
      if (
        dateBound != null &&
        Math.round((toDate.getTime() - fromDate.getTime()) / one_day) >=
          dateBound
      ) {
        isValidStartDate = false;
        startDateErrorMessage =
          'Greater than ' + dateBound + ' days is not allowed.';
        startDateCtr.setErrors({ invalidDate: true });
        return {
          startDateCtr,
          endDateCtr,
          isValidEndDate,
          isValidStartDate,
          startDateErrorMessage,
          endDateErrorMessage
        };
      }

      isValidStartDate = true;
      isValidEndDate = true;
      const error = startDateCtr.getError('invalidDate');
      if (error) {
        startDateCtr.setErrors(null);
      }
      return {
        startDateCtr,
        endDateCtr,
        isValidEndDate,
        isValidStartDate,
        startDateErrorMessage,
        endDateErrorMessage
      };
    } else {
      isValidStartDate = false;
      startDateErrorMessage = 'Invalid date.';
      startDateCtr.setErrors({ invalidDate: true });
      return {
        startDateCtr,
        endDateCtr,
        isValidEndDate,
        isValidStartDate,
        startDateErrorMessage,
        endDateErrorMessage
      };
    }
  }

  /**
   * Function call to check validations for End Date
   *
   * @param {number} dateBound
   * @param {FormControl} startDateCtr
   * @param {FormControl} endDateCtr
   * @param {boolean} isValidStartDate
   * @param {boolean} isValidEndDate
   * @param {String} startDateErrorMessage
   * @param {String} endDateErrorMessage
   * @return {*}
   * @memberof CommonService
   */
  validateEndDate(
    dateBound: number,
    startDateCtr: FormControl,
    endDateCtr: FormControl,
    isValidStartDate: boolean,
    isValidEndDate: boolean,
    startDateErrorMessage: String,
    endDateErrorMessage: String
  ) {
    if (!endDateCtr.invalid && endDateCtr.value != null) {
      isValidEndDate = true;
      isValidStartDate = true;
      startDateCtr.setErrors(null);
      var one_day = 1000 * 60 * 60 * 24;
      const fromDate = new Date(this.transform(startDateCtr));
      const toDate = new Date(this.transform(endDateCtr));

      if (fromDate > toDate || startDateErrorMessage == 'Invalid date.') {
        isValidEndDate = false;
        endDateErrorMessage =
          'End date must be equal or greater than start date';
        endDateCtr.setErrors({ invalidDate: true });
        return {
          startDateCtr,
          endDateCtr,
          isValidEndDate,
          isValidStartDate,
          startDateErrorMessage,
          endDateErrorMessage
        };
      }
      if (
        dateBound != null &&
        Math.round((toDate.getTime() - fromDate.getTime()) / one_day) >=
          dateBound
      ) {
        isValidEndDate = false;
        endDateErrorMessage =
          'Greater than ' + dateBound + ' days is not allowed.';
        endDateCtr.setErrors({ invalidDate: true });
        return {
          startDateCtr,
          endDateCtr,
          isValidEndDate,
          isValidStartDate,
          startDateErrorMessage,
          endDateErrorMessage
        };
      }

      isValidEndDate = true;
      isValidStartDate = true;
      const error = endDateCtr.getError('invalidDate');
      if (error) {
        endDateCtr.setErrors(null);
      }
      return {
        startDateCtr,
        endDateCtr,
        isValidEndDate,
        isValidStartDate,
        startDateErrorMessage,
        endDateErrorMessage
      };
    } else {
      isValidEndDate = false;
      endDateErrorMessage = 'Invalid date.';
      endDateCtr.setErrors({ invalidDate: true });
      return {
        startDateCtr,
        endDateCtr,
        isValidEndDate,
        isValidStartDate,
        startDateErrorMessage,
        endDateErrorMessage
      };
    }
  }

  public getFormattedDate(timezone: string, date: any): Moment {
    let finalDate: Moment = momentTimezone(date).tz(timezone);
    return finalDate;
  }
}
